/*
THIS COMPONENT INCLUDING IN ALL ADMIN PAGES
 ---------------------------------------------*/
let ClaimFormBuilder = (() => {
    const $urlDeleteField = '/shop/claim_forms/fields/';
    const $urlGetField = '/shop/claim_forms/get_field';
    const $buttonAdd = '#add-field';
    const $buttonDeleteClass = '.js-delete-field';
    const $containerFields = '#claim-fields';

    let init = () => {
        listenAdd();
        listenDelete();
        listenSubmit();
        initSortable();
    };

    /*
     |--------------------------------------------------------------------------
     | Adding new field
     |--------------------------------------------------------------------------
     */
    let listenAdd = () => {
        $(document).on('click', $buttonAdd, () => {
            let fieldIndex = $('.field-container').length;
            AppendNewField(fieldIndex);
        });
    };

    let AppendNewField = (fieldIndex) => {
        $.get($urlGetField, {fieldIndex: fieldIndex}).done( (response) => {
            $($containerFields).append(response);
        });
    };

    /*
     |--------------------------------------------------------------------------
     | Deleting given field
     |--------------------------------------------------------------------------
     */
    let listenDelete = () => {
        $(document).on('click', $buttonDeleteClass, function () {
            let field = $(this).parents('.field-container');
            let id;
            if (id = field.data('id')) {
                deleteFromDb(id, field);
                return true;
            }

            deleteLocal(field);
        });
    };

    let deleteFromDb = (id, field) => {
        if (confirm('Вы уверены, что хотите удалить это поле?')) {
            $.ajax({
                url: $urlDeleteField + id,
                method: 'POST',
                data: {
                    _method: 'DELETE'
                }
            }).done(() => {
                deleteLocal(field);
            });
        }
    };

    let deleteLocal = (field) => {
        field.remove();
    };

    /*
     |--------------------------------------------------------------------------
     | Set sorting for fields
     |--------------------------------------------------------------------------
     */
    let initSortable = () => {
        $($containerFields).sortable();
    };

    let listenSubmit = () => {
        $('form').on('submit', function () {
            $('.field-container').each(function (sortingIndex) {
                appendSortingInput($(this), sortingIndex);
            });

            return true;
        });
    };

    let appendSortingInput = (elem, sortingIndex) => {
        let fieldIndex = elem.data('index');
        elem.append(
            $('<input/>')
                .attr('type', 'hidden')
                .attr('name', 'form_fields[' + fieldIndex + '][sorting]')
                .val(sortingIndex + 1)
        );
    };

    return {
        init: init
    }
})();

export default ClaimFormBuilder;
